var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCancelWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74.603,
    height: 74.603
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "cancel-white_svg__a",
    width: 74.603,
    height: 74.603,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#805800",
    floodOpacity: 0.18
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "CANCEL BUTTON"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3284"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#cancel-white_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    "data-name": "Path 665"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.3 12a22.306 22.306 0 017.865 43.177A21.961 21.961 0 0137.3 56.6a22.3 22.3 0 010-44.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.302 13a21.232 21.232 0 00-15.063 6.24A21.232 21.232 0 0016 34.301a21.232 21.232 0 006.24 15.063 21.232 21.232 0 0015.062 6.238c2.622 0 5.216-.47 7.503-1.358 4.052-1.573 7.496-4.26 9.961-7.77a21.073 21.073 0 003.837-12.173 21.232 21.232 0 00-6.24-15.063A21.232 21.232 0 0037.303 13m0-1c12.317 0 22.301 9.985 22.301 22.302 0 9.471-5.904 17.564-14.436 20.875-2.3.894-5.02 1.426-7.865 1.426C24.985 56.603 15 46.62 15 34.302 15 21.985 24.985 12 37.302 12z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    "data-name": "Group 2666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.496 42.479l15.611-15.611",
    "data-name": "Line 90"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2665"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.479 42.107h0",
    "data-name": "Line 91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.249 39.877L29.868 26.496",
    "data-name": "Line 92"
  })))))));
}

export default SvgCancelWhite;